import isEmail from 'validator/es/lib/isEmail';

export const isEmailAddress = (input: string): boolean => isEmail(input);
